<template>
  <nav-bar title="新增开拓客户" />
  <Content bottom="0">
    <van-form class="form" ref="form" @submit="handleSubmit">
      <Picker
        label="客户类型"
        :require="true"
        :columns="columns"
        :defaultVal="formDefault.userTypeName"
        @confirm-values="selected"
      />
      <Field
        v-if="userType !== '04' && userType !== '05'"
        name="creditNo" label="客户代码"
        :require="true"
        :rules="[
          { required: true, message: '请填写客户代码' },
          { validator: asyncValidator, message: creditNoMessage }
        ]"
      />
      <Field name="companyName" label="客户名" :require="true" :defaultValue="formDefault.companyName" />
      <Field name="userName" label="联系人" :require="true" :defaultValue="formDefault.userName" />
      <Field name="phoneNum" label="联系电话" :require="true" :defaultValue="formDefault.phoneNum" />
      <Picker
        label="街道"
        :require="true"
        pickerType="cascader"
        :defaultVal="formDefault.streetName"
        @confirm-values="value => (street = value)"
      />
      <Field name="address" label="地址" :require="true" :defaultValue="formDefault.address" />
      <Field name="oldSupply" label="原供应商" :defaultValue="formDefault.oldSupply" />
      <Field name="illegalWeight" type="number" label="日违法用量" :defaultValue="formDefault.illegalWeight" />
      <Field name="reason" label="拓展原因" :require="true" :defaultValue="formDefault.reason" />
      <SelectPoint @get-value="selectPoint" :defaultValue="(formDefault.longitude || 0) +','+ (formDefault.latitude || 0)"/>
      <div class="btn-container">
        <van-button
          block
          type="primary"
          native-type="submit"
          :loading="loading"
          :disabled="loading"
        >
          确认提交
        </van-button>
      </div>
    </van-form>
  </Content>
</template>

<script>
import { Toast } from 'vant'
import { computed, ref } from 'vue'
import {
  addExtCustomer,
  getMessListById,
  queryCustomerMessForCom,
  updateCustomerMess
} from '@/api/customer'
import { useGetData } from '@/hooks/useGetData'
import { useSubmit, loading } from '@/hooks/useSubmit'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import SelectPoint from './SelectPoint.vue'

export default {
  name: 'NewCustomers', // 新增开拓客户
  components: { SelectPoint },
  setup() {
    const router = useRouter()
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const departId = computed(() => store.state.roleInfo.departId)
    const insertUserid = computed(() => store.state.userInfo.id)
    const street = ref('')

    const userType = ref('')
    const status = ref('1')
    const userId = ref('')
    const handleSubmit = values => {
      const params = {
        userStatus: '02',
        userType: userType.value,
        insertUserid: insertUserid.value,
        companyId: companyId.value,
        departId: departId.value,
        longitude: point.value ? point.value[1] : 0.0,
        latitude: point.value ? point.value[0] : 0.0,
        streetCode: street.value,
        checkedList: checkedList.value,
        userId: userId.value,
        ...values
      }
      const { onSubmit } = useSubmit(status.value === '1' ? addExtCustomer : updateCustomerMess, params, () => {
        router.back()
      })
      onSubmit()
    }

    // 选择位置
    const point = ref('') // 位置
    const selectPoint = value => {
      point.value = value
    }

    // LIST
    const columns = ref()
    useGetData(getMessListById, data => {
      columns.value = data
    })()
    const checked = ref({})
    const checkedList = computed(() => {
      const res = []
      for (const curKey in checked.value) {
        res.push({
          tid: curKey,
          key: checked.value[curKey]
        })
      }
      return res
    })
    const selected = val => {
      userType.value = val.dicVal
    }
    const formDefault = ref({})
    const isError = ref(false)
    const creditNoMessage = () => isError.value ? '验证出现错误' : '该客户代码已被占用'
    const isOk = ref(false)
    const isOkValue = ref('')
    const asyncValidator = (val) => {
      if (isOk.value && isOkValue.value === val) { return }
      const res = new Promise((resolve) => {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          message: '验证中...'
        })
        queryCustomerMessForCom({
          creditNo: val,
          companyId: companyId.value
        }).then(res => {
          res = res.data
          isError.value = false
          if (res.cuMess) {
            street.value = res.cuMess.streetCode
            userType.value = res.cuMess.userType
            userId.value = res.cuMess.userId
          }
          formDefault.value = res.cuMess || {}
          status.value = res.status
          isOk.value = true
          isOkValue.value = val
          resolve(res.status !== '2')
          Toast.clear()
        }).catch(() => {
          isError.value = true
          resolve(false)
          Toast.clear()
        })
      })
      return res
    }
    return {
      handleSubmit,
      loading,
      street,
      selectPoint,
      selected,
      columns,
      checked,
      checkedList,
      userType,
      asyncValidator,
      creditNoMessage,
      formDefault,
      status
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  margin: 16px;
}
.subject {
  margin-top: 16px;
  .subject-title {
    padding: 16px;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
    font-size: 14px;
    font-weight: 600;
  }
  .radio {
    padding: 10px 0;
  }
}
</style>
